<template>
  <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">Cambiar ordenes de compra en "transito" a una nueva área.</span>
      </v-card-title>
      <v-card-text>
        <span>Encontramos un total de "{{totalOrders}}" ordenes de compra con los siguientes estatus: "creada", "enviada", "confirmada" y "facturada". Por favor selecciona la nueva área a la cual se moverán.</span>
        <v-form ref="changePurchaseOrderArea" v-model="form.valid">
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-select
                  label="Selecciona un área"
                  v-model="form.data.area"
                  :items="areas"
                  item-text="name"
                  item-value="id"
                  return-object
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          class="mr-4"
          rounded
          small
          depressed
          @click="closeDialog('cancel')">
          {{ $t('orders.buttons.close') }}
        </v-btn>
        <v-btn
          color="success"
          class="mr-4"
          rounded
          small
          depressed
          :disabled="!form.data.area"
          @click="submit">
          {{ $t('orders.buttons.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
export default {
  props: {
    totalOrders: {
      type: Number,
      required: true
    },
    sourceAreaId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        valid: false,
        data: {
          area: null
        }
      }
    }
  },
  computed: {
    areas: function () {
      return (this.$store.state.currentRestaurant.areas.data || [])
        .filter(area => area._id !== this.sourceAreaId)
    },
    idRestaurant: function () {
      return this.$store.state.currentRestaurant.data._id || null
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.resetAreaForm()
      }
    }
  },
  methods: {
    submit: async function () {
      this.$refs.changePurchaseOrderArea.validate()

      if (this.form.valid) {
        this.overlay = true
        try {
          const payload = {
            destinyArea: this.form.data.area._id
          }
          await this.$api.put(`/v1/restaurants/${this.idRestaurant}/areas/${this.sourceAreaId}/change-orders-area`, payload)
          this.closeDialog('close')
          this.$toasted.show('Se cambiaron las ordenes de compra de área exitosamente.', { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
        }
        this.overlay = false
      }
    },
    resetAreaForm () {
      this.form.data = {
        area: null
      }
    },
    closeDialog (event) {
      this.isOpen = false
      this.$emit(event, false)
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>
